import { Box } from "@mui/system";
import React from "react";

const AppEmphBolder = ({children}: {children: React.ReactNode}) => <Box component="span" sx={{ fontWeight: 700, fontFamily: "Open Sans", fontStyle: "italic" }}>{children}</Box>
export default AppEmphBolder;